import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCakehomeRules as _getCakehomeRules, setCakehomeAdjust, getRuleTypes, getChannelOnlineFoodsList, getOnlineFoodsRuleTypes, delOnlineFoodsRule } from '@/api/goodsCenter';
import MenuAdjustDrawer from '@/views/mallDecoration/components/menuAdjustDrawer.vue';
import OnlineLoglist from '@/views/goodsCenter/onlineComponents/onlineLoglist.vue';
export default {
  name: 'onlineDiscount',
  components: {
    OnlineLoglist: OnlineLoglist,
    MenuAdjustDrawer: MenuAdjustDrawer
  },
  data: function data() {
    return {
      totalCount: 0,
      create_time: [],
      update_time: [],
      ruleForm: {
        rule_id: '',
        rule_name: '',
        rule_type: '',
        creator: '',
        updater_id: '',
        company_name: '',
        s_created_time: '',
        e_created_time: '',
        s_updated_time: '',
        e_updated_time: '',
        type: 'search',
        page: 1,
        pagesize: 20
      },
      ruleTypes: [],
      ruleList: [],
      pages: {},
      drawer: false,
      trendParams: {}
    };
  },
  computed: {
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    }
  },
  props: {
    trendParamsGood: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.getRuleTypes();
    this.getDate();
  },
  methods: {
    getDate: function getDate() {
      var _this = this;
      var params = this.ruleForm;
      if (this.trendParamsGood && this.trendParamsGood.rule_id) {
        params.rule_id = this.trendParamsGood.rule_id;
        params.company_name = this.trendParamsGood.company_name;
      }
      getChannelOnlineFoodsList(params).then(function (res) {
        _this.ruleList = res.data.data.data;
        _this.totalCount = res.data.data.totalCount;
      });
    },
    // 获取规则类型
    getRuleTypes: function getRuleTypes() {
      var _this2 = this;
      getOnlineFoodsRuleTypes().then(function (res) {
        _this2.ruleTypes = res.data.data;
      });
    },
    toAdjustRuleLog: function toAdjustRuleLog() {
      this.$router.push({
        name: 'CakeStoreAdjustLog'
      });
    },
    // 查询规则列表
    searchRule: function searchRule() {
      this.ruleForm.page = 1;
      this.getDate();
    },
    // 获取影院规则列表
    getCakehomeRules: function getCakehomeRules() {
      var _this3 = this;
      _getCakehomeRules(this.ruleForm).then(function (res) {
        _this3.ruleList = res.data.data.data;
        _this3.totalCount = res.data.data.totalCount;
      });
    },
    // 搜索框时间处理
    changeTime: function changeTime(val, flag) {
      if (flag) {
        this.ruleForm.s_updated_time = val ? val[0] : '';
        this.ruleForm.e_updated_time = val ? val[1] : '';
      } else {
        this.ruleForm.s_created_time = val ? val[0] : '';
        this.ruleForm.e_created_time = val ? val[1] : '';
      }
    },
    // 打开日志
    openLog: function openLog() {
      this.drawer = true;
    },
    // 打开调价规则
    openAdjustRuleDialog: function openAdjustRuleDialog(type, row) {
      this.$router.push({
        name: 'addOnlineBrandsAdjustRule',
        query: {
          type: type,
          rule_id: row.rule_id
        }
      });
    },
    // 保存设置规则
    emitSubmit: function emitSubmit(params) {
      var _this4 = this;
      setCakehomeAdjust(params).then(function (res) {
        var event = _this4.$refs.addCakeHomeAdjustRule;
        _this4.$message.success('保存成功');
        event.dialogVisible = false;
        _this4.getCakehomeRules();
      });
    },
    delRule: function delRule(row) {
      var _this5 = this;
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u5220\u9664\u89C4\u5219\u5417\uFF1F", '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        delOnlineFoodsRule({
          rule_id: row.rule_id
        }).then(function (res) {
          _this5.ruleList.splice(_this5.ruleList.indexOf(row), 1);
          _this5.$message.success('操作成功');
        });
      });
    },
    // 规则列表table 规则展示条件
    showRule: function showRule(adjust_type) {
      if (adjust_type.length == 2) {
        return 'all';
      } else if (adjust_type[0] == 1) {
        return 'ratio';
      } else if (adjust_type[0] == 2) {
        return 'money';
      } else {
        return '';
      }
    },
    // 分页操作
    onChange: function onChange(val) {
      this.ruleForm.page = val;
      this.getDate();
    },
    resetRuleForm: function resetRuleForm() {
      this.ruleForm = {
        rule_id: '',
        rule_name: '',
        rule_type: '',
        creator: '',
        updater_id: '',
        company_name: '',
        s_created_time: '',
        e_created_time: '',
        s_updated_time: '',
        e_updated_time: '',
        type: 'search',
        page: 1,
        pagesize: 20
      };
      this.create_time = [];
      this.update_time = [];
    }
  }
};